import { compact } from "lodash"

export const getUserLocationString = (user) => {
  return compact([user.city, user.state, user.country]).join(", ")
}
